import styled from "@emotion/styled";
export const StyledProductPrice = styled.div`
  min-height: ${({ isNewPricing, isCreditsPricing, crmClassic })=>crmClassic ? '96px' : isCreditsPricing ? '155px' : isNewPricing ? '120px' : '140px'};

  .price-tag {
    margin: 8px 0 8px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;

    &.has-yearly-savings-tooltip {
      position: relative;
      cursor: help;
      flex-wrap: wrap;
    }

    .amount {
      font-size: 2.7rem;
      margin-right: 4px;
      font-weight: 600;
    }

    .price-description {
      line-height: 18px;
      font-size: 0.8125rem;
      color: #323338;
      margin-bottom: 4px;
    }
  }

  .yearly-savings-tooltip {
    display: none;
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    z-index: 100;
    width: max-content;
    max-width: 280px;
    background-color: #323338;
    color: #ffffff;
    padding: 10px 12px;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    white-space: normal;
    pointer-events: none;
  }

  .yearly-savings-tooltip:after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 40px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 6px 6px 6px;
    border-color: transparent transparent #323338 transparent;
  }

  .price-tag.has-yearly-savings-tooltip:hover .yearly-savings-tooltip,
  .price-tag.has-yearly-savings-tooltip:focus .yearly-savings-tooltip,
  .price-tag.has-yearly-savings-tooltip:focus-within .yearly-savings-tooltip {
    display: block;
  }

  .price-tag.has-yearly-savings-tooltip:focus {
    outline: 2px solid #0073ea;
    outline-offset: 2px;
    border-radius: 4px;
  }

  .discount-chip {
    font-size: 12px;
    font-weight: 400;
    margin-left: 8px;
    color: #006278;
    background-color: #E7F4F6;
    padding: 2px 8px;
    border-radius: 4px;
  }

  .price-currency-text {
      font-size: 8px;
      font-weight: bold;
      margin-left: 4px;
  }
  .product-price-total-wrapper {
    display: flex;
    gap: 5px;
  }

  .credits-price-wrapper {
    display: block;
    line-height: 1.4;
  }
  .credits-price-wrapper > span {
    display: inline;
  }

  .credits-price-wrapper .product-price-total.credits-price-original {
    text-decoration: line-through;
    color: rgba(50, 51, 56, 0.3804);
    font-weight: 600;
  }

  .credits-price-wrapper .product-price-total.credits-billed-text {
    font-weight: 400;
  }

  .credits-nowrap {
    white-space: nowrap;
  }

  .credits-price-with-tooltip {
    position: relative;
    cursor: pointer;
  }

  .credits-tooltip {
    display: none;
    position: absolute;
    bottom: calc(100% + 12px);
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;
    width: max-content;
    max-width: 320px;
    background-color: #323338;
    color: #ffffff;
    padding: 14px 16px;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    text-align: left;
    white-space: normal;
  }

  .credits-tooltip:after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 8px 8px 0 8px;
    border-color: #323338 transparent transparent transparent;
  }

  .credits-price-with-tooltip:hover .credits-tooltip {
    display: block;
  }

  .credits-tooltip-line {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
    white-space: nowrap;
  }

  .credits-tooltip-value {
    font-weight: 600;
  }

  .product-price-billed-periodically {
    font-size: 0.875rem;
  }

  .product-price-total {
    font-size: 0.875rem;
    font-weight: bold;
  }

  .credits-price-wrapper .product-price-total {
    font-weight: 600;
  }

  .product-price-total.contacts-pricing-unit {
    font-size: 2.125rem;
  }

  .product-price-total.contacts-text-unit {
    font-size: 1.125rem;
  }

  .price-description-new {
    color:#676879;
    font-weight: 400;
    font-size: 14px;
    margin-top: 8px;
  }

  .crossed-price-meta {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    align-self: flex-start;
    margin-left: 4px;
    margin-top: 8px;
    gap: 2px;

    .crossed-out-price {
      margin-left: 0;
    }

    .price-description {
      margin-bottom: 0;
      line-height: 16px;
      white-space: nowrap;
    }

    .seat-month-inline {
      display: inline;
      white-space: nowrap;
      font-size: 0.8125rem;
      color: #323338;
      line-height: 16px;
    }
  }

  .crossed-out-price {
    color: var(--placeholder-color, #c5c7d0);
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    text-decoration: line-through;
    margin-left: 8px;

    &.before-amount {
      margin-left: 0;
      margin-right: 8px;
    }
  }

  .seat-month-inline {
    display: inline;
    white-space: nowrap;
    font-size: 0.8125rem;
    color: #323338;
    line-height: 16px;
  }

  .price-description-inline {
    font-size: 14px;
    font-weight: 300;
    line-height: 18px;
    color: inherit;
    margin-left: 8px;
    align-self: flex-end;
  }
`;
